export default __webpack_public_path__ + "static/media/bell.4b04e2c2.svg";